import React from 'react';
import ProjectLink from 'notifications/components/project_link';

const NotificationEntryLink = (props) => (
  <ProjectLink {...props} append={`entry/${props.entry.id}`}/>
)

export default NotificationEntryLink;
